import { SignedSaleOrder } from "@/api/orders/types";
import { getEIP712SignatureParams } from "@/eip712";
import { SIGNED_SALE_PARAMS } from "@/eip712/constants";
import { buildObject } from "@/shared/helpers";
import { useCallback } from "react";
import { useExchangeContractProxy } from "../useExchangeContract";
import { getFeeCut } from "@/shared/currencies";

export default function useSettleSignedSale(signedSale: SignedSaleOrder) {
  const exchangeContract = useExchangeContractProxy();

  return useCallback(
    async (value: string) => {
      const { v, r, s } = getEIP712SignatureParams(signedSale.signature!);

      const eip712AuctionObject = buildObject(
        {
          ...signedSale,
          makerCut: getFeeCut(signedSale.price, signedSale.makerFee),
          takerCut: getFeeCut(signedSale.price, signedSale.takerFee),
          royaltiesCut: getFeeCut(signedSale.price, signedSale.royaltiesFee),
          collectiveCut: getFeeCut(signedSale.price, signedSale.collectiveFee),
        },
        {},
        [...SIGNED_SALE_PARAMS],
      );

      return await exchangeContract!.buyFromSale(v, r, s, eip712AuctionObject, {
        value,
      });
    },
    [exchangeContract, signedSale],
  );
}
